import { ROLE_ADMIN } from '../constants/roles';

const RoleService = {
  getRoleString(role) {
    return role === ROLE_ADMIN ? 'admin' : 'renter';
  },
};

export default RoleService;



// WEBPACK FOOTER //
// ./src/services/RoleService.js